﻿window.occupancyproposal = function () {

    var LABEL_YES = "";
    var LABEL_NO = "";
    var LABEL_DELETE = "";

    function SetCheckBoxes() {

        var dropDownList = $("#SelectGroup").data("kendoDropDownList");
        if (dropDownList != null && dropDownList != undefined) {

            var listItems = dropDownList.dataSource.view();
            var selectedItem = listItems[dropDownList.select()];

            $("input[name='SelectGroupID']")[0].value = selectedItem.GroupID;

            var cbL = $("#OccupancyProposalLCD").data("kendoCheckBox");
            if (cbL != null && cbL != undefined) {
                cbL.element[0].checked = selectedItem.LCD_Enabled;
            }

            var cbP = $("#OccupancyProposalPager").data("kendoCheckBox");
            if (cbP != null && cbP != undefined) {
                cbP.element[0].checked = selectedItem.Pager_Enabled;
            }

            var cbPEU = $("#OccupancyProposalEachUser").data("kendoCheckBox");
            if (cbPEU != null && cbPEU != undefined) {
                cbPEU.element[0].checked = selectedItem.EachUser_Enabled;
            }

            var cbPOM = $("#OccupancyProposalForCustomOccupancyMin").data("kendoCheckBox");
            if (cbPOM != null && cbPOM != undefined) {
                cbPOM.element[0].checked = selectedItem.OccupancyProposalForCustomOccupancyMin_Enabled;
            }
        }

        LoadOtherViews();
    }


    function LoadOtherViews() {

        var dropDownList = $("#SelectGroup").data("kendoDropDownList");
        if (dropDownList != null && dropDownList != undefined) {

            var listItems = dropDownList.dataSource.view();
            var selectedItem = listItems[dropDownList.select()];

            //--- NoOccupancyProposalMessageTable ---//
            if (selectedItem.LCD_Enabled ||
                selectedItem.Pager_Enabled ||
                selectedItem.EachUser_Enabled) {
                $("#divOccupancyProposalTable").load(appsettings.getUrl("OccupancyProposal/GetTable?groupId=" + selectedItem.GroupID));
                main.setHideDiv("divOccupancyProposalTable", true);
            } else {
                main.setHideDiv("divOccupancyProposalTable", false);
            }

            //--- Counters ---//
            $("#divOccupancyProposalCounters").load(appsettings.getUrl("OccupancyProposal/GetCounters?groupId=" + selectedItem.GroupID));

            //--- LastMsg ---//
            if (selectedItem.ShowLastMsg) {
                $("#divOccupancyProposalLastMessage").load(appsettings.getUrl("OccupancyProposal/GetLastMessage?groupId=" + selectedItem.GroupID));
            }
            main.setHideDiv("divOccupancyProposalLastMessage", selectedItem.ShowLastMsg);
        }
    }

    function NoOccupancyProposalList_reloadListView(groupId) {

        // Get Data
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("OccupancyProposal/LoadNoOccupancyProposalList") + "?groupId=" + groupId,
            data: { groupId: groupId },
            success: function (responseData) {
                if (responseData != undefined) {
                    var listView = $("#NoProposalForMessagesWith_CplSelected").data("kendoListBox");
                    listView.dataSource.data(responseData.items);
                }
            }
        });
    }

    function NoOccupancyProposalList_removeMessage(groupId) {

        var messagesArr = [];

        var listView = $("#NoProposalForMessagesWith_CplSelected").data("kendoListBox");

        if (listView != undefined) {

            var items = listView.select();
            var allitems = listView.items();

            for (var cnt = 0; cnt < items.length; cnt++) {
                var idx = allitems.index(items[cnt]);
                var dataItem = listView.dataSource.view()[idx];
                messagesArr[cnt] = parseInt(dataItem.Value);
            }
        }

        var list = messagesArr.slice();

        // Post Data
        $.ajax({
            type: "POST",
            url: appsettings.getUrl("OccupancyProposal/RemoveMessagesFromGroup"),
            data: { list: kendo.stringify(list), groupId: groupId },
            success: function (responseData) {

                // refresh list
                NoOccupancyProposalList_reloadListView(groupId);

                if (responseData != undefined && responseData != null) {

                    if (responseData.Succesfully == false) {
                        main.openActionsDialog(' ', responseData.Message,
                            [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    } else {

                        // disable delete button
                        document.getElementById("NoOccupancyProposalList_delete-button").setAttribute("disabled", "disabled");
                    }
                }

            }
        });
    }


    return {

        Initialize: function (labelYes, labelNo, labelDelete) {
            LABEL_YES = labelYes;
            LABEL_NO = labelNo;
            LABEL_DELETE = labelDelete;
        },

        OnGroupsLoaded: function () {
            SetCheckBoxes();
        },

        OnGroupChanged: function () {
            SetCheckBoxes();
        },

        ReloadDDL: function () {
            var dropDownList = $("#SelectGroup").data("kendoDropDownList");
            if (dropDownList != null && dropDownList != undefined) {
                dropDownList.dataSource.read();
            }
        },

        TBNoProposalForMessages_inputChanged: function () {
            var btnAdd = document.getElementById("NoOccupancyProposalList_add-button");
            btnAdd.removeAttribute("disabled");
        },

        NoOccupancyProposalList_enableDeleteButton: function () {
            var btnDelete = document.getElementById("NoOccupancyProposalList_delete-button");
            btnDelete.removeAttribute("disabled");
        },

        NoOccupancyProposalList_addClicked: function (groupId) {

            var inp = document.getElementById("TBNoProposalForMessages");

            if (inp != undefined) {

                // Post Data
                $.ajax({
                    type: "POST",
                    url: appsettings.getUrl("OccupancyProposal/Add_NoProposalForMessageWith_ToGroup"),
                    data: { label: inp.value, groupId: groupId },
                    success: function (responseData) {
                        // refresh list
                        NoOccupancyProposalList_reloadListView(groupId);

                        if (responseData != undefined && responseData != null) {
                            if (responseData.Succesfully == false) {
                                main.openActionsDialog(' ', responseData.Message,
                                    [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                            } else {
                                // clear add field
                                document.getElementById("TBNoProposalForMessages").value = "";

                                // disable Add button
                                document.getElementById("NoOccupancyProposalList_add-button").setAttribute("disabled", "disabled");
                            }
                        }
                    }
                });
            }
        },

        NoOccupancyProposalList_deleteClicked: function (groupId, questionMessage, yesText, noText) {
            main.openActionsDialog(' ', questionMessage,
                [{ text: yesText, action: function () { NoOccupancyProposalList_removeMessage(groupId); main.closePopup(); } },
                { text: noText, action: function () { main.closePopup(); } }]);
        },

        UpdateCountersClicked: function (groupId) {

            // Serialize the occupancyProposalCounters

            var post_data = new Object();
            post_data.GroupID = groupId;
            post_data.CounterValues = new Array();

            var cntrVals = $("input[id^='TB_']");

            for (var i = 0; i < cntrVals.length; i++) {

                var idsplit = cntrVals[i].id.split('_');

                // create new counter object
                var occupancyCounter = new Object();
                occupancyCounter.UserID = idsplit[1];
                occupancyCounter.ServiceFunctionID = idsplit[2];
                occupancyCounter.Value = cntrVals[i].value;
                occupancyCounter.Show = true;

                post_data.CounterValues.push(occupancyCounter);
            }

            // Post Data
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("OccupancyProposal/SaveCounters"),
                data: post_data,

                success: function (responseData) {
                    // Show request result
                    form.showServerResponse("form_OccupancyProposalCounter", responseData);
                }
            });            
        },

        LastMessage_resetClicked: function (msgGroupId, groupId) {

            // Post Data
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("OccupancyProposal/ResetCounters"),
                data: { msgGroupId: msgGroupId },

                success: function (responseData) {

                    // refresh counters view
                    $("#divOccupancyProposalCounters").load(appsettings.getUrl("OccupancyProposal/GetCounters?groupId=" + groupId));

                    // Disable reset button
                    main.setHideKendoUIFormItem3("LastMessage_reset-button", false);

                    // Show request result
                    form.showServerResponse("form_OccupancyProposalMsg", responseData);
                }
            });
        }
    }

}();